import axios from "axios";
import { pathAPI } from "./pathAPI";

export const getContrastingColor = (hexColor: string): string => {
  const color = hexColor.replace("#", "");
  const r = parseInt(color.substring(0, 2), 16);
  const g = parseInt(color.substring(2, 4), 16);
  const b = parseInt(color.substring(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5 ? "black" : "white";
};

export const detectDeviceType = (): "android" | "iphone" | "windows" | "other" => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (/android/i.test(userAgent)) {
    return "android";
  } else if (/iphone|ipad|ipod/i.test(userAgent)) {
    return "iphone";
  } else if (/windows/i.test(userAgent)) {
    return "windows";
  }
  return "other";
};

export const loadImage = async (imgPath: string | undefined, setImageUrl: React.Dispatch<React.SetStateAction<string>>, setIsImageLoading: React.Dispatch<React.SetStateAction<boolean>>) => {
  if (!imgPath) return;
  setIsImageLoading(true);
  try {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}${imgPath}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "https://wifi.vtctelecom.com.vn",
        "Access-Control-Allow-Methods": "POST, GET, OPTIONS",
        "Access-Control-Allow-Headers": "Content-Type, Authorization",
      },
      responseType: "blob",
    });
    setImageUrl(URL.createObjectURL(response.data));
    setIsImageLoading(false);
  } catch (error) {
    console.error("Error loading image:", error);
    setIsImageLoading(false);
  }
};

export const loadImageBanner = async (imgPath: string | undefined, setBannerUrl: React.Dispatch<React.SetStateAction<string>>, setIsImageLoading: React.Dispatch<React.SetStateAction<boolean>>) => {
  if (!imgPath) return;
  setIsImageLoading(true);
  try {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}${imgPath}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "https://wifi.vtctelecom.com.vn",
        "Access-Control-Allow-Methods": "POST, GET, OPTIONS",
        "Access-Control-Allow-Headers": "Content-Type, Authorization",
      },
      responseType: "blob",
    });
    setBannerUrl(URL.createObjectURL(response.data));
    setIsImageLoading(false);
  } catch (error) {
    console.error("Error loading image:", error);
    setIsImageLoading(false);
  }
};

export const loadImageTablet = async (imgPath: string | undefined, setImageTabletUrl: React.Dispatch<React.SetStateAction<string>>, setIsImageLoading: React.Dispatch<React.SetStateAction<boolean>>) => {
  if (!imgPath) return;
  setIsImageLoading(true);
  try {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}${imgPath}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "https://wifi.vtctelecom.com.vn",
        "Access-Control-Allow-Methods": "POST, GET, OPTIONS",
        "Access-Control-Allow-Headers": "Content-Type, Authorization",
      },
      responseType: "blob",
    });
    setImageTabletUrl(URL.createObjectURL(response.data));
    setIsImageLoading(false);
  } catch (error) {
    console.error("Error loading image:", error);
    setIsImageLoading(false);
  }
};

export const loadImageDesktop = async (imgPath: string | undefined, setImageDesktopUrl: React.Dispatch<React.SetStateAction<string>>, setIsImageLoading: React.Dispatch<React.SetStateAction<boolean>>) => {
  if (!imgPath) return;
  setIsImageLoading(true);
  try {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}${imgPath}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "https://wifi.vtctelecom.com.vn",
        "Access-Control-Allow-Methods": "POST, GET, OPTIONS",
        "Access-Control-Allow-Headers": "Content-Type, Authorization",
      },
      responseType: "blob",
    });
    setImageDesktopUrl(URL.createObjectURL(response.data));
    setIsImageLoading(false);
  } catch (error) {
    console.error("Error loading image:", error);
    setIsImageLoading(false);
  }
};

export const loadVideo = async (videoPath: string | undefined, setVideoUrl: React.Dispatch<React.SetStateAction<string>>, setIsVideoLoading: React.Dispatch<React.SetStateAction<boolean>>) => {
  if (!videoPath) return;
  setIsVideoLoading(true);
  try {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}${videoPath}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "https://wifi.vtctelecom.com.vn",
        "Access-Control-Allow-Methods": "POST, GET, OPTIONS",
        "Access-Control-Allow-Headers": "Content-Type, Authorization",
      },
      responseType: "blob",
    });
    setVideoUrl(URL.createObjectURL(response.data));
    setIsVideoLoading(false);
  } catch (error) {
    console.error("Error loading video:", error);
    setIsVideoLoading(false);
  }
};

export const loadLogo = async (logoPath: string | undefined, setLogoUrl: React.Dispatch<React.SetStateAction<string>>, setIsLogoLoading: React.Dispatch<React.SetStateAction<boolean>>, showMainContent: boolean) => {
  if (!logoPath) return;
  setIsLogoLoading(true);
  try {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}${logoPath}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "https://wifi.vtctelecom.com.vn",
        "Access-Control-Allow-Methods": "POST, GET, OPTIONS",
        "Access-Control-Allow-Headers": "Content-Type, Authorization",
      },
      responseType: "blob",
    });
    setLogoUrl(URL.createObjectURL(response.data));
    const logoPartner = document.getElementById("logoPartner");
    const logoVTC = document.getElementById("logoVTC");

    if (logoPartner && showMainContent) {
      (logoPartner as HTMLImageElement).src = URL.createObjectURL(response.data);
      setIsLogoLoading(false);
    } else {
      setIsLogoLoading(false);
      if (logoVTC) {
        logoVTC.style.display = "none";
      }
    }
  } catch (error) {
    console.error("Error loading logo:", error);
    setIsLogoLoading(false);
  }
};

export const addImpressionTags = (impressionTagImage?: string, impressionTagFrame?: string, impressionTagJs?: string) => {
  const cleanupFunctions: (() => void)[] = [];

  // Xử lý impression tag hình ảnh
  if (impressionTagImage) {
    const img = document.createElement("img");
    const matchResult = impressionTagImage.match(/SRC="([^"]+)"/);
    if (matchResult) {
      img.src = matchResult[1];
      img.style.display = "none";
      img.onerror = () => console.error("Failed to load impression image:", img.src);
      document.body.appendChild(img);
      cleanupFunctions.push(() => {
        if (document.body.contains(img)) document.body.removeChild(img);
      });
    }
  }

  // Xử lý impression tag iframe
  if (impressionTagFrame) {
    const iframe = document.createElement("iframe");
    const matchResult = impressionTagFrame.match(/SRC="([^"]+)"/);
    if (matchResult) {
      iframe.src = matchResult[1];
      iframe.style.display = "none";
      iframe.onerror = () => console.error("Failed to load impression iframe:", iframe.src);
      document.body.appendChild(iframe);
      cleanupFunctions.push(() => {
        if (document.body.contains(iframe)) document.body.removeChild(iframe);
      });
    }
  }

  // Xử lý impression tag JavaScript
  if (impressionTagJs) {
    const script = document.createElement("script");
    const matchResult = impressionTagJs.match(/SRC="([^"]+)"/);
    if (matchResult) {
      let src = matchResult[1];
      // Thay thế các tham số động
      src = src
        .replace("[timestamp]", Date.now().toString())
        .replace("${GDPR}", "0") // Thay đổi theo logic GDPR thực tế
        .replace("${GDPR_CONSENT_755}", "");
      script.src = src;
      script.type = "text/javascript";
      script.setAttribute("language", "JavaScript1.1");
      script.setAttribute("attributionsrc", "");
      script.onerror = () => console.error("Failed to load impression script:", src);
      document.body.appendChild(script);
      cleanupFunctions.push(() => {
        if (document.body.contains(script)) document.body.removeChild(script);
      });
    } else {
      console.error("Invalid impression_tag_3rd_party_js format:", impressionTagJs);
    }
  }

  // Cleanup tất cả các elements khi component unmount
  return () => {
    cleanupFunctions.forEach((cleanup) => cleanup());
  };
};
export const sendTrackingData = async (eventData: any) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL_TEST}${pathAPI.trackActivity}`, eventData, {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
        "Access-Control-Allow-Origin": "https://wifi.vtctelecom.com.vn",
        "Access-Control-Allow-Methods": "POST, GET, OPTIONS",
        "Access-Control-Allow-Headers": "Content-Type, Authorization",
      },
    });
    return response.data;
  } catch (err) {
    console.error("Failed to send tracking data:", err);
  }
};

// If you want to keep this as a React component, rename this file to adUtils.tsx
